import type { TMedia } from '~constants/media';
import { FadeInImage } from '~shared/ui/atoms/FadeInImage';
import { backgroundFromLetter } from '~utils/backgroundFromLetter';

import { avatarImage, StyledUserAvatar } from './styled';

type Props = {
	links?: TMedia[];
	name?: string;
	width?: number;
	height?: number;
	className?: string;
};

export const UserAvatar = ({
	name,
	links,
	width,
	height,
	className,
}: Props) => {
	const [backgroundColor, letter] = backgroundFromLetter(name);
	const avatarStyle = links?.length ? undefined : { backgroundColor };

	return (
		<StyledUserAvatar
			align="center"
			justify="center"
			className={className}
			style={avatarStyle}
		>
			{links?.length ? (
				<FadeInImage
					className={avatarImage}
					media={links}
					width={width}
					height={height}
					alt={name ?? ''}
					fallback=""
				/>
			) : (
				<span>{letter}</span>
			)}
		</StyledUserAvatar>
	);
};
